var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header d-xl-block d-none"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{attrs:{"to":_vm.isUserMinistry
            ? { name: 'ministry-dashboard' }
            : _vm.user.ngo
            ? { name: 'ngo-profile' }
            : { name: 'temp-ngo' }}},[_c('div',{staticClass:"navbar-brand"},[_c('span',{staticClass:"my-1"},[_c('b-img',{attrs:{"height":"60px","src":_vm.isUserMinistry
                  ? require('@/assets/images/logo/MinistryLogo.png')
                  : require('@/assets/images/logo/header-logo.png'),"alt":"logo"}})],1),_c('h2',{staticClass:"brand-text mb-0"},[_vm._v(" "+_vm._s(_vm.appName)+" ")])])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }